import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ManufacturerArticleLot } from '../check-order-manufacturer.models';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';

@Component({
  selector: 'app-check-order-lots',
  standalone: false,
  templateUrl: './check-order-lots.component.html',
  styleUrls: ['./check-order-lots.component.scss'],
})
export class CheckOrderLotsComponent {
  @Input() public productToWorkOn: ProcessingOrders.IProductInOrder | null =
    null;
  @Input({ required: true }) public lots: ManufacturerArticleLot[] = [];
  @Input() public completed = false;
  actionLabel = 'AGGIUNGI LOTTO';
  hasBatchLabel = 'ELABORA LOTTO'
  viewBatchLabel = 'VISUALIZZA'

  @Output()
  public readonly articleSelected =
    new EventEmitter<ProcessingOrders.IProductInOrder>();
  @Output()
  public readonly batchSelected =
    new EventEmitter<ProcessingOrders.IProductBatch>();
  @Output() public readonly articleAction = new EventEmitter<number>()
  @Output() public readonly openLot = new EventEmitter<number>();

  public mServ = inject(ManufacturerPopoversService);
  public orderService = inject(OrderHelperService);

  get actionIcon(): string {
    return this.actionLabel === 'AGGIUNGI LOTTO' ? 'bx-plus' : 'bx-cog';
  }

  get batchActionIcon(): string {
    return this.hasBatchLabel === 'ELABORA LOTTO' ? 'bx-cog' : 'bx-plus';
  }

  public triggerAction2(code: number, event: Event): void {
    event.stopPropagation();
    this.openLot.emit(code);
    console.log('reviewing batches', code, event);
  }

  public triggerAction(code: number, event: Event): void {
    event.stopPropagation();
    this.articleAction.emit(code);
    console.log('adding batch and range', code, event);
  }


  openBatch(product, lot) {
    this.orderService.selectedProduct.next(product);
    this.orderService.selectedBatch.next(lot);
    this.orderService.selectedDocuments.next(lot?.documents);
    this.mServ.openBatch();
  }

}
